// src/store/useApplicationStore.ts
import { create } from "zustand";

type ApplicationStore = {
  tenantCode: string | null;
  applicationId: string | null;
  setAppContext: (tenantCode: string, applicationId: string) => void;
};

export const useApplicationStore = create<ApplicationStore>((set) => ({
  tenantCode: null,
  applicationId: null,
  setAppContext: (tenantCode, applicationId) => set({ tenantCode, applicationId }),
}));
